import React, {Component} from "react";
import {getBaseURL} from "components/helpers/HostURLHelper.jsx";
import {withStyles} from '@material-ui/core/styles';
import ComboBox from "./core/ComboBox.jsx";
import ReportListItem from "./core/ReportListItem.jsx";
import Grid from '@material-ui/core/Grid';
import qs from 'query-string';

const styles = ((theme) => ({
  filters: {
    display: "flex",
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
    flexWrap: "wrap"
  }
}));

class AnalystStudentHome extends Component {
  state = {
    selectedStudentId: "",
    allStudents: [],
    studentSearchString: "",
    allBranches: [],
    allSections: [],
    selectedBranch: "",
    selectedSection: ""
  };

  componentDidMount() {
    this.fetchBranchesAndSections();
    this.getUserResults("");
  }

  fetchBranchesAndSections = () => {
    $.ajax({
      type: "GET",
      url: getBaseURL() + "/analysis/branches-sections.json"
    }).done((data) => {
      const allBranches = [{name: "All", branch_id: ""}, ...data.branches.map(b => ({name: b.name, branch_id: b.id}))];
      const allSections = [{name: "All", section_id: ""}, ...data.sections.map(s => ({name: s.name, section_id: s.id}))];
      this.setState({allBranches, allSections});
    });
  };

  getUserResults = (searchString = this.state.studentSearchString) => {
    const {selectedBranch, selectedSection} = this.state;
    let uri = '/analysis/students.json';
    const params = {};
    if (searchString) params.search = searchString;
    if (selectedBranch) params.branch_id = selectedBranch;
    if (selectedSection) params.section_id = selectedSection;

    const query = qs.stringify(params);
    if (query) uri += "?" + query;

    $.ajax({
      type: 'GET',
      url: getBaseURL() + uri,
    }).done((data) => {
      this.setState({allStudents: data["students"]})
    });
  };

  onStudentSearchInputChange = (e) => {
    const value = e.target.value;
    this.setState({studentSearchString: value});
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.getUserResults(value), 800);
  };

  onSelectStudent = (event, option) => {
    this.setState({selectedStudentId: option.id});
  };

  onSelectBranch = (e, option) => {
    this.setState({selectedBranch: option?.branch_id || ""}, this.getUserResults);
  };

  onSelectSection = (e, option) => {
    this.setState({selectedSection: option?.section_id || ""}, this.getUserResults);
  };

  allStudentsOptionLabel = (option) => option.username + " (" + option.name + ")";

  goToStudentReport = () => {
    const {selectedStudentId} = this.state;
    if (selectedStudentId) {
      this.props.history.push('/analysis/student/report?student_id=' + selectedStudentId);
    } else {
      alert("Please select a student");
    }
  };

  render() {
    const {classes} = this.props;
    const {selectedStudentId, allStudents, allBranches, allSections} = this.state;
    return (
      <React.Fragment>
        <div className={classes.filters}>
          <ComboBox onInputChange={this.onStudentSearchInputChange} optionLabel={this.allStudentsOptionLabel} options={allStudents} onChange={this.onSelectStudent} label={"Search Student"}/>
          <ComboBox options={allBranches} onChange={this.onSelectBranch} label="Filter by Branch"/>
          <ComboBox options={allSections} onChange={this.onSelectSection} label="Filter by Section"/>
        </div>
        <div style={{padding: "30px 0px", minHeight: "10vh"}}>
          <Grid container spacing={4}>
            <Grid item sm={12} md={4}>
              <ReportListItem isDisabled={!selectedStudentId} onView={this.goToStudentReport} role={{title: "Full Student Report", subtitle: "Complete report of a student"}}/>
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AnalystStudentHome);
